import axios from "axios";

const BASE_URL = "/api";

const api = axios.create({
  baseURL: BASE_URL
});

// 🔐 REQUEST → ajouter token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// 🔁 RESPONSE → auto refresh
api.interceptors.response.use(
  (response) => response,

  async (error) => {
    const originalRequest = error.config;

    // sécurité
    if (!originalRequest) {
      return Promise.reject(error);
    }

    // 🔥 si 401 → tenter refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          throw new Error("Pas de refresh token");
        }

        const res = await axios.post(
          `${BASE_URL}/auth/refresh`,
          { refreshToken }
        );

        const newAccessToken = res.data.accessToken;

        // 🔄 sauvegarder
        localStorage.setItem("accessToken", newAccessToken);

        // 🔁 rejouer la requête initiale
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        return api(originalRequest);

      } catch (err) {
        console.error("Refresh token échoué");

        // 🧹 nettoyage propre
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        alert("Session expirée, veuillez vous reconnecter");

        window.location.href = "/";

        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;